import { ReactElement } from "react";
import RefCircle from "logic/src/components/RefCircle";
import BaseStreamRender, {
  // IOptions,
  IInfo,
  IText2ImageInfo,
  IWebSearchInfo,
  ITextFileInfo,
  ITextInfo,
  IStatusInfo,
  IVideoEditInfo,
  IThinkingInfo,
} from "logic/src/objects/chat/BaseStreamRenderV2";
import MarkdownText from "../components/MarkdownTextV2";
// import WebSearch from "../components/WebSearch";
import { ReactComponent as ArrowRight } from "logic/src/components/icons/arrowRight.svg";

import StatusLoading from "@/components/StatusLoading";
import { EMoeToolStatus } from "logic/src/objects/session/types";
import { EFuntionCall } from "logic/src/objects/session/types";
import { EChatType, EStreamDataType } from "logic/src/objects/chat/types";
import AiImage from "logic/src/components/AiImage";
import VideoClipper from "../../VideoUnderstanding/components/VideoClipper";
import styles from "./styles.module.scss";

interface IVideoInfo {
  url: string;
  fileId: string;
}

export interface IRenderContentEvent {
  type: "videoTimeClick" | "webSearchClick";
  data: any;
}

type TRenderContentListener = (e: IRenderContentEvent) => void;

class StreamRender {
  children: ReactElement[] = [];
  baseRender: BaseStreamRender;
  pureMarkdown: boolean = false;
  RefCircle = RefCircle;
  onEvent: TRenderContentListener = () => {};

  videoInfoList: IVideoInfo[] | null = null;
  sessionId: string = "";
  onContentChange: (
    list: ReactElement[],
    originList: IInfo[],
    thinkingInfo: IThinkingInfo | null,
  ) => void = () => {};

  constructor({
    baseRender,
    onContentChange,
  }: {
    baseRender: BaseStreamRender;
    onContentChange: (
      list: ReactElement[],
      originList: IInfo[],
      thinkingInfo: IThinkingInfo | null,
    ) => void;
  }) {
    this.baseRender = baseRender;
    this.onContentChange = onContentChange;
    baseRender.setOnContentChange(() => this.updateComponent());
  }

  setVideoInfoList(v: IVideoInfo[] | null) {
    this.videoInfoList = v;
    this.updateComponent();
  }

  setSessionId(v: string) {
    this.sessionId = v;
  }
  setPureMarkdown(v: boolean) {
    this.pureMarkdown = v;
  }

  setOnEvent(v: TRenderContentListener) {
    this.onEvent = v;
  }

  handleWebsearchClick = () => {
    console.log("handleWebsearchClick", this.baseRender.web_searchs);
    this.onEvent({
      type: "webSearchClick",
      data: this.baseRender.web_searchs,
    });
  };

  updateComponent() {
    const list = this.baseRender.last
      ? [...this.baseRender.history, this.baseRender.last]
      : this.baseRender.history;

    this.children = list.map(item => {
      // if (item.type === EMoeToolType.files) {
      //   return (
      //     <FileList
      //       onImageLoad={this.onImageLoad}
      //       key={item.id}
      //       isImage={(item as IFileListInfo).fileType === "image"}
      //       fileList={(item as IFileListInfo).fileList}
      //     />
      //   );
      // } else
      if (item.type === EStreamDataType.text) {
        return (
          <MarkdownText
            webSearch={this.baseRender.web_searchs}
            sessionId={this.sessionId}
            onEvent={this.onEvent}
            key={item.id}
            content={(item as ITextInfo).textFlow || ""}
            incrementRef={this.pureMarkdown}
          />
        );
        // if (this.pureMarkdown) {
        //   return (
        //     <MarkdownText
        //       sessionId={this.sessionId}
        //       onEvent={this.onEvent}
        //       key={item.id}
        //       content={(item as ITextInfo).textFlow?.rawText || ""}
        //     />
        //   );
        // } else {
        //   return (
        //     <Text
        //       webSearch={this.baseRender.web_searchs}
        //       key={item.id}
        //       contentList={(item as ITextInfo).textFlow?.htmlList}
        //       content={(item as ITextInfo).htmlContent}
        //       complete={
        //         this.baseRender.type === EChatType.history
        //           ? true
        //           : this.baseRender.end
        //       }
        //     />
        //   );
        // }
      } else if (item.type === "image") {
        const info = item as ITextFileInfo;
        if (info.status === "init") {
          return <span key={item.id}></span>;
        } else {
          return (
            <AiImage
              key={item.id}
              loading={info.status === "loading"}
              name={info.name}
              src={info.url}
              className={styles.img}
            />
          );
        }
      } else if (item.type === EStreamDataType.text2image) {
        if (!(item as IText2ImageInfo).text2image.startsWith("http")) {
          return (
            <div key={item.id}>{(item as IText2ImageInfo).text2image}</div>
          );
        }
        return (
          <AiImage
            key={item.id}
            src={(item as IText2ImageInfo).text2image}
            className={styles.img}
            name={"image.png"}
          />
        );
      }
      // else if (item.type === EStreamDataType.web_searcher) {
      //   return (
      //     <div
      //       className={styles.websearch}
      //       key={item.id}
      //       onClick={this.handleWebsearchClick}
      //     >
      //       <span>
      //         {`找到了 ${(item as IWebSearchInfo).weabSearch?.length} 篇资料作为参考  `}
      //       </span>
      //       <ArrowRight className={styles.websearchIcon} />
      //     </div>
      //   );
      // }
      else if (item.type === EStreamDataType.videoEdit) {
        const parser = (item as IVideoEditInfo).videoParser;
        return this.videoInfoList && this.videoInfoList?.length > 0 ? (
          <VideoClipper
            key={item.id}
            sessionId={this.sessionId}
            status={parser.parseData.status}
            clipSegmentObs={parser.parseData.data || []}
            videosInfo={this.videoInfoList!}
          />
        ) : (
          <div key={item.id}></div>
        );
        // return (
        //   <div>
        //     {parser.parseData.status}
        //     {parser.parseData.data?.toString()}
        //   </div>
        // );
      } else if (item.type === EStreamDataType.thinking) {
        return <div key={item.id}></div>;
      }
      // else if (item.type === EMoeToolType.code) {
      //   return (
      //     <CodeBlock
      //       key={item.id}
      //       result={(item as ICodeInfo).result}
      //       code={(item as ICodeInfo).code}
      //       files={(item as ICodeInfo).files}
      //       status={(item as ICodeInfo).status}
      //     />
      //   );
      // }
      else if (item.type === EStreamDataType.status) {
        return (
          <StatusLoading
            key={item.id}
            type={
              (item as IStatusInfo).statusType === EMoeToolStatus.text2image
                ? EFuntionCall.text2image
                : (item as IStatusInfo).statusType ===
                    EMoeToolStatus.web_searcher
                  ? EFuntionCall.web_search
                  : EFuntionCall.thinking
            }
            completed={(item as IStatusInfo).end}
          ></StatusLoading>
        );
      } else {
        return <div key={item.id}></div>;
      }
    });

    this.onContentChange(this.children, list, this.baseRender.thinkingInfo);
  }
}

export default StreamRender;
